import { Injectable } from '@angular/core';

import { DataQueryWithTagDtoWithRelations } from '@osos/shared/api';
import { FilterExpressionModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

import {
  DataQueryPresenterModel,
  FilterExpressionPresenterModel,
  FilterExpressionValueTypeEnum,
} from '@osos/shared/types';
import { FieldFactoryService } from '../../factories';

@Injectable()
export class QueryParseV1Service extends ParserBase<
  DataQueryWithTagDtoWithRelations,
  DataQueryPresenterModel
> {
  constructor(private fieldFactory: FieldFactoryService) {
    super(DataQueryWithTagDtoWithRelations, DataQueryPresenterModel, 1);
  }

  getPresenterModel(
    model: DataQueryWithTagDtoWithRelations,
  ): DataQueryPresenterModel {
    const presenter = {
      specificationVersion: this.version,
    } as DataQueryPresenterModel;
    presenter.id = model?.id;
    presenter.name = model.name;
    presenter.dataEntity = model.dataEntity;
    presenter.useInQuickFilter = model.useInQuickFilter;
    presenter.criteria = this.parseCriteria(
      model.criteria as FilterExpressionModel,
    );
    presenter.parameters = model.parameters?.map((parameter) => {
      return {
        name: parameter.name,
        field: this.fieldFactory.createPresenterModel(parameter.field as any),
        fieldEntityId: parameter.fieldEntityId,
      };
    });
    presenter.isParameterized = model.isParameterized;
    presenter.dataSource = model.dataSource;
    presenter.tag = model.tag;
    presenter.updateIdentifier = model.updateIdentifier;
    return presenter;
  }
  getDataModel(
    presenter: DataQueryPresenterModel,
  ): DataQueryWithTagDtoWithRelations {
    const model = {
      specificationVersion: this.version,
      visibility: 0,
      name: presenter.name,
      dataEntity: presenter.dataEntity,
      criteria: presenter.criteria,
      parameters: presenter.parameters?.map((parameter) => {
        return {
          name: parameter.name,
          field: this.fieldFactory.createDataModel(parameter.field),
          fieldEntityId: parameter.fieldEntityId,
        };
      }),
      isParameterized: !!presenter.parameters?.length,
      useInQuickFilter: presenter.useInQuickFilter,
      tag: presenter.tag,
      updateIdentifier: presenter.updateIdentifier,

      // @TODO: collection & query should be come from the component once supporting them in data-query
      dataSource: { ...presenter.dataSource, collection: '', query: '' },
    } as DataQueryWithTagDtoWithRelations;

    return model;
  }

  private parseCriteria(
    filter: FilterExpressionModel,
    presenter = {} as FilterExpressionPresenterModel,
  ): FilterExpressionPresenterModel {
    // Our basecase is when we find the field property on the object
    if (Object.keys(filter).includes('field')) {
      presenter.field = filter.field;
      presenter.operator = filter.operator;
      presenter.fieldOperator = filter?.fieldOperator;
      presenter.args =
        filter.args?.[0]?.value !== null &&
        filter.args?.[0]?.value !== undefined
          ? filter.args
          : [
              {
                type: FilterExpressionValueTypeEnum.Fixed,
                value: filter.args?.[0] || null,
              },
            ];
    } else {
      presenter.operator = filter.operator;
      presenter.args = Array(filter.args?.length)
        .fill(null)
        .map(() => ({}) as FilterExpressionPresenterModel);
      filter.args.forEach((arg, index) => {
        this.parseCriteria(arg, presenter.args[index]);
      });
    }
    return presenter;
  }
}
